<template>
  <div class="flex justify-center bg-blue-lighter py-11">
    <div class="container mx-auto w-full max-w-3xl px-4">
      <Title custom-style="mb-9">{{ $t('what-are-you-looking-for') }}</Title>
      <div class="relative flex flex-1 flex-col md:flex-row md:items-end">
        <SearchAlgolia :initial-query="textInput" :is-loading="isLoading" class="w-full" />
      </div>
    </div>
  </div>
</template>

<script setup>
import { Title } from 'refresh-ui'
import SearchAlgolia from '../elements/SearchAlgolia.vue'

const props = defineProps({
  textInput: String,
  isLoading: Boolean,
})

const text = ref(props.textInput)

watch(
  () => props.textInput,
  () => (text.value = props.textInput),
)
</script>
